<template>
	<div class="source-wrap">
		<div class="type-wrap">
			<span class="type-title">精品车源</span>
			<span class="tag">抢品质好货</span>
			<div class="country-wrap">
				<div
					class="country-item"
					v-for="(item, index) in countryList"
					:key="index"
					@click="handleIsLogin(item)"
				>
					<span
						:style="{
							color:
								countryIndex == index
									? 'rgba(254, 118, 72, 1)'
									: 'rgba(29, 32, 137, 1)'
						}"
						class="country-name"
						>{{ item.Name }}</span
					>
				</div>
			</div>
			<div @click="handleIsLogin" class="more-wrap">
				查看更多<span class="el-icon-arrow-right" />
			</div>
		</div>
		<div v-if="!this.token" class="content-wrap unlogined-wrap">
			<div class="img-wrap-l"></div>
			<div
				class="detail-wrap"
				v-for="(item, index) in list"
				:key="index"
				@click="handleLogin"
			>
				<div class="img-wrap">
					<el-image
						style="width: 100%; height: 100%; object-fit: cover"
						:src="item.Pic"
						fit="cover"
					></el-image>
				</div>
				<div class="detail-content-wrap">
					<div class="tag-wrap">
						<span class="tag" :style="item.MctCode | getShopColor"
							>{{ item.MctName }}<span class="el-icon-arrow-right"
						/></span>
						<span class="tag" v-if="item.Pic">100%实物图 </span>
					</div>
					<div class="vehicle-wrap">
						{{ item.VehicleName }}
					</div>
				</div>
			</div>
		</div>
		<div v-else class="logined-wrap">
			<div
				class="bg-wrap"
				style="overflow: hidden; border-radius: 10px; width: 310px"
			>
				<el-image
					style="width: 100%; height: 100%"
					:src="require('@/assets/dash_common/chyuan_dl.png')"
					fit="cover"
				></el-image>
			</div>
			<div>
				<vue-seamless-scroll
					v-if="list && list.length > 0"
					class="seamless-scroll"
					:data="list"
					:class-option="classOption"
				>
					<!-- <div class="scroll-list-wrap">
            <div
              v-for="(item, index) in list"
              :key="index"
              style="
                margin-right: 25px;
                background-color: red;
                width: 300px;
                height: 400px;
                font-size: 60px;
                color: #fff;
              "
            >
              {{ index }}
            </div>
          </div> -->

					<div class="right-wrap" style="height: 400px">
						<div
							@click="handleToDetail(item)"
							class="detail-wrap"
							style="width: 350px; margin-right: 25px"
							v-for="(item, index) in list"
							:key="index"
						>
							<div class="img-wrap">
								<!-- <el-image
                  style="width: 100%; height: 100%"
                  :src="item.Pic"
                  fit="cover"
                ></el-image> -->
								<img
									style="width: 100%; height: 100%; object-fit: cover"
									:src="item.Pic"
								/>
							</div>
							<div class="detail-content-wrap">
								<div class="tag-wrap">
									<span
										class="tag"
										:style="item.MctCode | getShopColor"
										@click.stop="handelGoShop(item)"
										>{{ item.MctName }}<span class="el-icon-arrow-right"
									/></span>
									<span class="tag" v-if="item.Pic">100%实物图</span>
								</div>
								<div class="vehicle-wrap">
									{{ item.VehicleName }}
								</div>
							</div>
						</div>
					</div>
				</vue-seamless-scroll>
			</div>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex"
import {TopCountry} from "@/api/merchant/dashboard"
import vehicleSelect from "../../parts/list/components/vehicleSelect.vue"
export default {
	components: {vehicleSelect},
	inject: ["getSourceList"],
	computed: {
		list() {
			return this.getSourceList()
		},
		...mapGetters(["token"])
	},
	data() {
		return {
			// countryList: [
			//   {
			//     ID: null,
			//     Name: "中国",
			//     Url: null,
			//     SubName: null,
			//   },
			//   {
			//     ID: null,
			//     Name: "美国",
			//     Url: null,
			//     SubName: null,
			//   },
			//   {
			//     ID: null,
			//     Name: "德国",
			//     Url: null,
			//     SubName: null,
			//   },
			//   {
			//     ID: null,
			//     Name: "日本",
			//     Url: null,
			//     SubName: null,
			//   },
			//   {
			//     ID: null,
			//     Name: "其他",
			//     Url: null,
			//     SubName: null,
			//   },
			// ],
			countryList: [],
			countryIndex: 0,
			classOption: {
				direction: 2
				// autoPlay:false
			}
		}
	},
	created() {
		TopCountry().then((res) => {
			this.countryList = res
		})
	},
	methods: {
		handelGoShop(e) {
			console.log(e, 99999)
			this.$router.push({
				path: "/shop-list",
				query: {MctCode: e.MctCode}
			})
			// this.$router.push("/shop-list")
		},
		handleToDetail(e) {
			this.$router.push({path: "/options-details", query: {id: e.ID}})
		},
		handleToList(item) {
			const {Name} = item
			this.$router.push({
				name: "options",
				params: {
					VehicleName: Name
				}
			})
			//   this.$router.push("/options")
		},
		handleLogin() {
			this.$emit("login", true)
		},
		handleIsLogin(item) {
			if (!this.token) {
				this.handleLogin()
				// return true;
			} else {
				this.handleToList(item)
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.seamless-scroll {
	height: 400px;
	overflow: hidden;
	.scroll-list-wrap {
		display: flex;
	}
}
.source-wrap {
	margin-bottom: 15px;
	.type-wrap {
		position: relative;
		margin-bottom: 15px;
		padding: 7px 20px 7px 27px;
		border-radius: 10px;
		background: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		.type-title {
			font-size: 26px;
			font-weight: 500;

			color: rgba(29, 32, 137, 1);
		}
		.tag {
			position: relative;
			// padding: 15px 12px 15px 7px;
			padding-left: 7px;
			padding-right: 12px;
			padding-top: 5px;
			padding-bottom: 5px;
			background: linear-gradient(
				90deg,
				rgba(249, 212, 35, 1) 0%,
				rgba(248, 54, 0, 1) 100%
			);
			font-size: 14px;
			font-weight: 400;
			color: rgba(255, 255, 255, 1);
			border-radius: 6px;
			margin-left: 18px;
			&::before {
				position: absolute;
				content: "";
				border-width: 6px;
				border-style: solid;
				border-color: transparent rgba(249, 212, 35, 1) transparent transparent;
				left: -12px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.country-wrap {
			display: flex;
			margin-left: 40px;
			//   .active {
			//     color: rgba(254, 118, 72, 1);
			//   }
			.country-item {
				& + .country-item {
					margin-left: 40px;
				}

				display: flex;
				align-items: center;
				.country-name {
					cursor: pointer;
					font-size: 20px;
					font-weight: 600;
					//   color: rgba(29, 32, 137, 1);
				}
			}
		}
		.more-wrap {
			cursor: pointer;
			position: absolute;
			font-size: 16px;
			font-weight: 400;
			color: rgba(56, 56, 56, 1);
			right: 20px;
		}
	}
	.content-wrap {
		display: grid;
		grid-template-columns: 310px auto auto auto;
		grid-template-rows: repeat(2, 275px);
		grid-gap: 10px;

		&.unlogined-wrap {
			height: 560px;
			overflow: hidden;
			> .img-wrap-l {
				grid-row: 1/3;
				border-radius: 10px;
				background-image: url("~@/assets/dash_common/cheyuan.png");
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				// height: 180px;
			}
			.img-wrap {
				height: 180px;
			}
		}
	}
	.logined-wrap {
		display: grid;
		grid-template-columns: 310px 1fr;
		// // grid-template-columns: 310px repeat(3, 350px);
		grid-column-gap: 20px;
		grid-template-rows: 400px;
		overflow: hidden;

		// display: flex;
		// grid-column-gap: 20px;

		// .bg-wrap{
		//   background-image: url(https://img.js.design/assets/img/63464f5bc1a4a87fac3ea1be.jpg#2893fb15d0d6e4b05012e298de3e1692);
		//   background-size: cover;
		//   background-position: center;
		//   background-repeat: no-repeat;

		// }
		.img-wrap {
			height: 300px;
			// height: 308px;
		}
		.right-wrap {
			display: flex;
			// grid-template-columns: repeat(3, 350px);
			// grid-column-gap: 25px;

			// display: flex;
			// // display: grid;
			// // grid-template-columns: repeat(3, 1fr);
			// // grid-template-rows: 400px;
			// grid-column-gap: 25px;
			// overflow: hidden;

			// display: flex;
			// overflow: hidden;

			// grid-column-gap: 25px;
		}
	}
	.detail-wrap {
		cursor: pointer;
		// flex-basis: 350px;
		// flex-shrink: 0;
		// margin-right: 25px;
		background-color: white;
		border-radius: 10px;
		// padding: 0 0 13px;
		overflow: hidden;

		.detail-content-wrap {
			padding: 17px 8px 8px 17px;
			.tag-wrap {
				margin-bottom: 8px;
				.tag {
					padding: 3px 13px;
					border-radius: 30px;
					color: white;
					&:nth-of-type(1) {
						background-color: rgba(0, 186, 173, 1);
					}
					&:nth-of-type(2) {
						background-color: rgba(176, 177, 177, 1);
					}
					& + .tag {
						margin-left: 10px;
					}
				}
			}
			.vehicle-wrap {
				font-size: 15px;
				font-weight: 500;
				color: rgba(56, 56, 56, 1);
				word-break: break-all;
			}
		}
	}
}
</style>
